import "./Footer.css";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  return (
    <div className="container poetsen-one-regular">
      <div className="footer">
        {location.pathname !== "/home" && (
          <>
            <div className="footer-desc">
              IMPORTANT DISCLAIMER: The information on this treasury dashboard
              is provided as is, without warranty of any kind. We source data
              from trusted providers, but accuracy and completeness aren't
              guaranteed. This content is for informational purposes only and
              shouldn't be used for investment, financial, or tax decisions.
              Consult your own experts for personalized advice.
              <br />
              Digital asset references are illustrative only and don't
              constitute investment advice or recommendations. We don't offer
              financial services or advice.
              <br />
              By using this website, you acknowledge that you understand and
              agree to these terms.
            </div>
            <div className="footer-main">
              <div className="copyright-comp">
                <i className="fa fa-copyright"></i> 2024 Condo
              </div>
              <div className="tnc-footer">Terms and Conditions</div>
              <div className="privacy-footer">Privacy Policy</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Footer;
